import { Typography } from '@mui/material'
import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'
import useStyles from './useStyles'

function TopesTable({ appParameters = [], parameters = [], refresh }) {
  const classes = useStyles()
  return (
    <>
      <div className={classes.root}>
        <div className={classes.tableWrap}>
          <table className={classes.table} >
            <TableHeader />
            <tbody className={classes.tableBody}>
              {appParameters.length > 0 && appParameters.map((item, index) => (
                <TableItem
                  key={item.app_parameter_code}
                  listIndex={index}
                  item={item}
                  refresh={refresh}
                  parameterData={parameters.find((p) => p.app_parameter_code === item.app_parameter_code)}
                />
              ))}
            </tbody>
          </table>
          {!appParameters.length && (
            <div style={{ display: "flex", justifyContent: "center", width: '100%' }}>
              <Typography
                style={{
                  fontSize: 16,
                  color: "#6e7a76",
                  textAlign: "center",
                  padding: "20px"
                }}
              >
                No hay topes asociados a la aplicación
              </Typography>
            </div>
          )}

        </div>
      </div>
    </>
  )
}
export default TopesTable
